import React from 'react';
import { XMarkIcon } from './icons';

interface TermsOfServiceProps {
  isOpen: boolean;
  onClose: () => void;
}

export const TermsOfService: React.FC<TermsOfServiceProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
        {/* ヘッダー */}
        <div className="flex items-center justify-between p-6 border-b">
          <h2 className="text-xl font-bold text-slate-900">利用規約</h2>
          <button
            onClick={onClose}
            className="text-slate-400 hover:text-slate-600"
          >
            <XMarkIcon className="w-6 h-6" />
          </button>
        </div>

        {/* コンテンツ */}
        <div className="p-6 max-h-[70vh] overflow-y-auto">
          <div className="prose prose-slate max-w-none">
            <h1 className="text-2xl font-bold mb-6">プロフィールスタジオ 利用規約</h1>
            
            <p className="mb-6">
              本規約は、利用者（以下「ユーザー」といいます。）が「プロフィールスタジオ」（以下「本サービス」といいます。）を利用するにあたり適用される条件を定めるものです。本サービスを利用することにより、ユーザーは本規約に同意したものとみなします。
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">第1条（適用）</h2>
            <p className="mb-4">
              本規約は、本サービスの提供条件及び本サービスの利用に関する当社（株式会社オレンジアーク、以下「当社」）とユーザーとの間の権利義務関係を定めるものです。
            </p>
            <p className="mb-6">
              当社は、本規約の内容をユーザーに通知することなく改定できるものとします。改定後にユーザーが本サービスを利用した場合、当該改定に同意したものとみなします。
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">第2条（利用登録）</h2>
            <p className="mb-4">
              ユーザーは、本サービスの利用にあたり、Googleログイン等、当社が指定する方法により登録を行うことができます。
            </p>
            <p className="mb-6">
              匿名利用（ゲスト利用）については、当社が定める範囲内で体験利用を許可します。
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">第3条（禁止事項）</h2>
            <p className="mb-4">ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。</p>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>法令または公序良俗に違反する行為</li>
              <li>著作権、肖像権その他の知的財産権を侵害する行為</li>
              <li>わいせつ、差別的、暴力的、誹謗中傷的な画像の生成または利用</li>
              <li>本サービスを不正に利用し、過剰にアクセスする行為（複数アカウントの作成、システムへの攻撃等を含む）</li>
              <li>生成結果を虚偽広告、詐欺その他の不正目的で利用する行為</li>
            </ul>

            <h2 className="text-xl font-semibold mt-8 mb-4">第4条（画像データの取扱い）</h2>
            <p className="mb-4">
              ユーザーがアップロードした画像は、加工処理の目的のみに利用し、原則として処理後短期間で削除します。
            </p>
            <p className="mb-4">
              当社は、ユーザーの同意なくアップロード画像をAI学習データとして利用しません。
            </p>
            <p className="mb-6">
              生成された画像の著作権は当社に帰属しますが、ユーザーは契約プランの範囲内で利用することができます。
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">第5条（利用料金と決済）</h2>
            <p className="mb-4">本サービスの利用料金は以下の通りとします。</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li><strong>Free（無料）</strong>：3枚（買い切り）。低解像度（保存時）。商用利用不可。ログイン不要。</li>
              <li><strong>Standard（¥500 買い切り）</strong>：10枚（買い切り）。高解像度。全機能利用可。</li>
              <li><strong>Pro（¥1,000 買い切り）</strong>：25枚（買い切り）。高解像度。全機能利用可。</li>
              <li><strong>Pro Max（¥5,000/月）</strong>：月200枚。高解像度。全機能利用可。</li>
            </ul>
            <p className="mb-4">
              決済はStripe等、当社が指定する外部決済サービスを通じて行います。
            </p>
            <p className="mb-4">
              決済処理に関する不具合やトラブルについて、当社は一切の責任を負いません。
            </p>
            <p className="mb-6">
              支払済みの利用料金は、理由を問わず返金いたしません。
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">第6条（免責事項）</h2>
            <p className="mb-4">
              本サービスにより生成された画像の品質、正確性、適法性について、当社は一切保証しません。
            </p>
            <p className="mb-4">
              本サービスの利用によりユーザーまたは第三者に生じた損害について、当社は一切の責任を負いません。
            </p>
            <p className="mb-6">
              本サービスの利用に関し、ユーザーと第三者との間で生じた紛争についても、当社は一切関与しません。
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">第7条（サービスの変更・停止）</h2>
            <p className="mb-4">
              当社は、ユーザーに事前通知することなく、本サービスの内容を変更、追加、停止することがあります。
            </p>
            <p className="mb-6">
              天災地変、通信障害、API提供元の停止等によりサービス提供が困難になった場合、当社は責任を負いません。
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">第8条（準拠法・裁判管轄）</h2>
            <p className="mb-6">
              本規約は日本法を準拠法とし、本サービスに関して生じる紛争については、横浜地方裁判所を第一審の専属的合意管轄裁判所とします。
            </p>

            <div className="text-right text-sm text-slate-500 mt-8">
              2025年9月20日 制定
            </div>
          </div>
        </div>

        {/* フッター */}
        <div className="border-t p-4 bg-slate-50 text-center">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
          >
            閉じる
          </button>
        </div>
      </div>
    </div>
  );
};

